import { render, staticRenderFns } from "./STEP5.vue?vue&type=template&id=8223ea7e&scoped=true&"
import script from "./STEP5.vue?vue&type=script&lang=js&"
export * from "./STEP5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8223ea7e",
  null
  
)

export default component.exports